(function () {
  "use strict";

  var STORAGE_PREFIX = "collectionMosaicGrid:";
  var VALID_MODES = ["featured", "hero-blocks", "compact"];
  var layoutAnchorRestoreToken = 0;

  function applyPersistedLayout(list) {
    if (!list) return;
    var handle = list.getAttribute("data-mosaic-collection-handle");
    if (!handle) return;
    try {
      var saved = localStorage.getItem(STORAGE_PREFIX + handle);
      if (saved && VALID_MODES.indexOf(saved) !== -1) {
        list.setAttribute("data-mosaic-layout", saved);
      }
    } catch (e) {}
  }

  function persistLayout(list, mode) {
    if (!list || VALID_MODES.indexOf(mode) === -1) return;
    var handle = list.getAttribute("data-mosaic-collection-handle");
    if (!handle) return;
    try {
      localStorage.setItem(STORAGE_PREFIX + handle, mode);
    } catch (e) {}
  }

  function syncButtons(section, mode) {
    section.querySelectorAll(".grid-selector__icon[data-mosaic-toggle]").forEach(function (btn) {
      var on = btn.getAttribute("data-mosaic-toggle") === mode;
      btn.classList.toggle("active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  function captureViewportAnchor(list) {
    if (!list) return null;
    var cards = list.querySelectorAll(".collection-mosaic__item");
    if (!cards.length) return null;

    var bestCard = null;
    var bestScore = Number.POSITIVE_INFINITY;
    var viewportCenter = window.innerHeight / 2;
    for (var i = 0; i < cards.length; i++) {
      var rect = cards[i].getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) continue;
      var cardCenter = rect.top + rect.height / 2;
      var score = Math.abs(cardCenter - viewportCenter);
      if (score < bestScore) {
        bestScore = score;
        bestCard = cards[i];
      }
    }
    if (!bestCard) bestCard = cards[0];

    var bestLink = bestCard.querySelector(".mosaic-card__full-link, .mosaic-card__media[href]");
    var href = bestLink ? bestLink.getAttribute("href") : null;
    if (!href) return null;

    return {
      href: href,
      center: (function () {
        var rect = bestCard.getBoundingClientRect();
        return rect.top + rect.height / 2;
      })()
    };
  }

  function findCardByHref(list, href) {
    if (!list || !href) return null;
    var links = list.querySelectorAll(".mosaic-card__full-link, .mosaic-card__media[href]");
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute("href") === href) {
        return links[i].closest(".collection-mosaic__item");
      }
    }
    return null;
  }

  function restoreViewportAnchor(list, anchor) {
    if (!list || !anchor || !anchor.href) return null;
    var card = findCardByHref(list, anchor.href);
    if (!card) return null;
    var rect = card.getBoundingClientRect();
    var cardCenter = rect.top + rect.height / 2;
    var delta = cardCenter - anchor.center;
    if (Math.abs(delta) > 1) window.scrollBy(0, delta);
    return delta;
  }

  function restoreViewportAnchorAfterLayout(list, anchor) {
    if (!anchor || !list) return;
    layoutAnchorRestoreToken += 1;
    var token = layoutAnchorRestoreToken;
    var settledFrames = 0;
    var startedAt = performance.now();
    var maxDurationMs = 1800;
    var settleThresholdPx = 0.75;
    var settleFramesNeeded = 4;

    function stabilizeRestore() {
      if (token !== layoutAnchorRestoreToken) return;
      var delta = restoreViewportAnchor(list, anchor);
      if (delta == null) return;

      if (Math.abs(delta) <= settleThresholdPx) settledFrames += 1;
      else settledFrames = 0;

      if (settledFrames >= settleFramesNeeded) return;
      if (performance.now() - startedAt > maxDurationMs) return;
      requestAnimationFrame(stabilizeRestore);
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        stabilizeRestore();
      });
    });
  }

  // ✅ UPDATED: initSection now uses new scroll
  function initSection(section) {
    var list = section.querySelector("product-list.collection-mosaic__grid");
    if (!list) return;

    applyPersistedLayout(list);
    var mode = list.getAttribute("data-mosaic-layout") || "featured";
    syncButtons(section, mode);
    if (typeof window.syncMosaicImageSizes === "function") {
      window.syncMosaicImageSizes(list);
    }
    if (typeof window.scheduleApplyMosaicCompactSlides === "function") {
      window.scheduleApplyMosaicCompactSlides(list);
    }

    initHeaderScroll(section); // ✅ new scroll logic
  }

  // ---------------------------------------------
  // ✅ NEW SCROLL LOGIC (replaces old one)
  // ---------------------------------------------

  // ---------------------------------------------
// ✅ STABLE SCROLL LOGIC (mobile: top/up show full chrome; down-pause shows only bottom nav)
// ---------------------------------------------

var MIN_DELTA = 4;
var PAUSE_DELAY = 1000;
/** Mosaic mobile (≤768px): show full chrome this long after last scroll event */
var PAUSE_DELAY_MOBILE = 500;
/** After row height/opacity transition (see collection-mosaic.css mobile / tablet rows) */
var ROW_EASE_MS = 400;
/** Mobile scroll-down collapse: wait ≥ parent motion (≤768px .collection-header--chrome-collapse --ch-mobile-dur) + buffer. */
var MOBILE_CHROME_COLLAPSE_MS = 520;
var LAYOUT_SETTLE_MS = MOBILE_CHROME_COLLAPSE_MS;
/** Desktop mosaic rows — matches ~0.72s transitions in collection-mosaic.css (min-width: 769px) */
var DESKTOP_ROW_TRANSITION_MS = 720;
/** Row 3 follows row 2 slightly when expanding from collapsed (desktop only) */
var DESKTOP_ROW3_STAGGER_MS = 100;
var DESKTOP_LAYOUT_SETTLE_MS = DESKTOP_ROW_TRANSITION_MS + DESKTOP_ROW3_STAGGER_MS + 160;
/**
 * Time until chrome-expand classes peel off + scroll settle (ignore fake deltas).
 * Covers mobile row/nav max-height + opacity motion.
 */
var MOBILE_CHROME_REVEAL_MS = 1500;

var sectionsState = new Map();
var scrollBound = false;
var resizeMOBound = false;
var lastMosaicMobileView = null;
var lastUserScrollInputAt = 0;

function atTop() {
  return window.scrollY <= 5;
}

function isMosaicMobileView() {
  return typeof window.matchMedia === "function" && window.matchMedia("(max-width: 768px)").matches;
}

function prefersReducedMotion() {
  return (
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

function noteUserScrollInput() {
  lastUserScrollInputAt = performance.now();
}

function hasRecentUserScrollInput(now) {
  return now - lastUserScrollInputAt < 220;
}

/** After ch-hidden toggles, scrollY can jump (clamped) and fire a fake “scroll up”. Sync + ignore briefly. */
function syncScrollAfterLayout(section) {
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      var st = sectionsState.get(section);
      if (st) st.lastScrollY = window.scrollY;
    });
  });
}

function isBackToTopVisible(btt) {
  if (!btt) return false;
  var header = btt.closest(".collection-header");
  if (!header) return false;
  if (isMosaicMobileView()) {
    return header.classList.contains("collection-header--show-back-to-top");
  }
  var row = btt.closest(".collection-header__back-to-top-row");
  return !!(row && row.classList.contains("is-visible") && !row.classList.contains("ch-hidden"));
}

function scrollPageToTop() {
  if (prefersReducedMotion()) {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    return;
  }

  try {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  } catch (e) {
    window.scrollTo(0, 0);
  }
}

var lastBackToTopAt = 0;

function finishBackToTopRestore() {
  sectionsState.forEach(function (state, section) {
    hideBackToTopRow(state);
    showAll(section);
    state.lastScrollY = window.scrollY;
    state.programmaticScrollUntil = 0;
  });
}

function handleBackToTop(event) {
  var btt = event.target.closest("[data-collection-back-to-top]");
  if (!btt || !isBackToTopVisible(btt)) return;

  var now = performance.now();
  if (now - lastBackToTopAt < 350) return;
  lastBackToTopAt = now;

  event.preventDefault();
  if (event.type === "touchend") event.stopPropagation();

  var section = btt.closest(".shopify-section--main-collection-mosaic");
  var sectionState = section ? sectionsState.get(section) : null;
  var scrollLockMs = prefersReducedMotion() ? 400 : isMosaicMobileView() ? 2500 : 2000;

  if (sectionState) {
    sectionState.programmaticScrollUntil = now + scrollLockMs;
    sectionState.suppressMobileAutoCollapseUntil = now + scrollLockMs;
    sectionState.settleUntil = now + scrollLockMs;
    sectionState.lastDirection = "up";
    sectionState.lastScrollY = window.scrollY;
    clearTimeout(sectionState.timer);
    noteUserScrollInput();
  }

  scrollPageToTop();

  if (prefersReducedMotion()) {
    finishBackToTopRestore();
    return;
  }

  var scrollDoneTimer = setTimeout(finishBackToTopRestore, scrollLockMs);
  function onScrollToTopProgress() {
    if (!atTop()) return;
    clearTimeout(scrollDoneTimer);
    window.removeEventListener("scroll", onScrollToTopProgress);
    finishBackToTopRestore();
  }
  window.addEventListener("scroll", onScrollToTopProgress, { passive: true });
}

function clearBttHideTimer(s) {
  if (!s || !s.bttHideTimer) return;
  clearTimeout(s.bttHideTimer);
  s.bttHideTimer = null;
}

/** Defer [hidden] on the back-to-top control so it stays in the layout during the row collapse. */
function scheduleBackToTopHidden(s) {
  if (!s || !s.backToTopBtn) return;
  clearBttHideTimer(s);
  if (s.backToTopBtn.hasAttribute("hidden")) return;
  var hideMs = isMosaicMobileView() ? ROW_EASE_MS : DESKTOP_ROW_TRANSITION_MS;
  s.bttHideTimer = setTimeout(function () {
    if (s.backToTopBtn) s.backToTopBtn.setAttribute("hidden", "");
    s.bttHideTimer = null;
  }, hideMs);
}

function hideBackToTopRow(s) {
  if (!s) return;
  clearDesktopRow3Reveal(s);
  if (isMosaicMobileView()) {
    if (s.header) {
      s.header.classList.remove("collection-header--show-back-to-top");
      s.header.classList.remove("collection-header--mobile-overlay");
    }
    if (s.backToTopBtn) s.backToTopBtn.setAttribute("hidden", "");
    return;
  }
  if (s.row3) {
    s.row3.classList.add("ch-hidden");
    s.row3.classList.remove("is-visible");
  }
  scheduleBackToTopHidden(s);
}

function setMobileBackToTopVisible(s, visible) {
  if (!s || !s.header) return;
  s.header.classList.toggle("collection-header--show-back-to-top", !!visible);
  if (!s.backToTopBtn) return;
  if (visible) s.backToTopBtn.removeAttribute("hidden");
  else s.backToTopBtn.setAttribute("hidden", "");
}

function syncHeaderRowsCollapsedClass(section) {
  if (isMosaicMobileView()) return;
  var s = sectionsState.get(section);
  if (!s || !s.header) return;
  var collapsed = !!(s.row2 && s.row2.classList.contains("ch-hidden"));
  s.header.classList.toggle("collection-header--rows-collapsed", collapsed);
}

function syncMosaicMobileHeaderChrome(section) {
  var s = sectionsState.get(section);
  if (!s || !s.header) return;
  s.header.classList.remove("mosaic-mobile--all", "mosaic-mobile--none");
  if (!isMosaicMobileView()) return;
  if (s.state === "m-full" || s.state === "m-nav-only") s.header.classList.add("mosaic-mobile--none");
  else s.header.classList.add("mosaic-mobile--all");
}

function initHeaderScroll(section) {
  if (!section) return;

  var header = section.querySelector('.collection-header');
  if (!header) return;

  if (header.dataset.scrollInit === "true") return;
  header.dataset.scrollInit = "true";

  var row1 = header.querySelector(".collection-header__top");
  var row2 = header.querySelector(".collection-header__row2");
  var mobileActions = header.querySelector(".collection-header__mobile-actions");
  var row3 = header.querySelector(".collection-header__back-to-top-row");
  var backToTopBtn = row3 ? row3.querySelector("[data-collection-back-to-top]") : null;
  var bottomNav = document.querySelector(".ch-bottom-nav");

  sectionsState.set(section, {
    header: header,
    row1: row1,
    row2: row2,
    mobileActions: mobileActions,
    row3: row3,
    backToTopBtn: backToTopBtn,
    bottomNav: bottomNav,
    lastScrollY: window.scrollY,
    timer: null,
    bttHideTimer: null,
    chromeRevealTimer: null,
    desktopRow3RevealTimer: null,
    revealStaggerTimers: [],
    state: "all-visible",
    settleUntil: 0,
    suppressMobileAutoCollapseUntil: 0,
    programmaticScrollUntil: 0,
    mobileOverlayCollapseTimer: null
  });

  // initial state
  showAll(section);

  if (!scrollBound) {
    scrollBound = true;
    window.addEventListener("touchstart", noteUserScrollInput, { passive: true });
    window.addEventListener("touchmove", noteUserScrollInput, { passive: true });
    window.addEventListener("wheel", noteUserScrollInput, { passive: true });
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  if (!resizeMOBound) {
    resizeMOBound = true;
    lastMosaicMobileView = isMosaicMobileView();
    window.addEventListener("resize", function () {
      var now = isMosaicMobileView();
      if (now === lastMosaicMobileView) return;
      lastMosaicMobileView = now;
      sectionsState.forEach(function (st, sec) {
        showAll(sec);
      });
    });
  }
}

function clearRevealStaggerTimers(s) {
  if (!s || !s.revealStaggerTimers || !s.revealStaggerTimers.length) return;
  for (var i = 0; i < s.revealStaggerTimers.length; i++) {
    clearTimeout(s.revealStaggerTimers[i]);
  }
  s.revealStaggerTimers.length = 0;
}

function clearDesktopRow3Reveal(s) {
  if (!s || !s.desktopRow3RevealTimer) return;
  clearTimeout(s.desktopRow3RevealTimer);
  s.desktopRow3RevealTimer = null;
}

function clearMobileOverlayCollapseTimer(s) {
  if (!s || !s.mobileOverlayCollapseTimer) return;
  clearTimeout(s.mobileOverlayCollapseTimer);
  s.mobileOverlayCollapseTimer = null;
}

/**
 * Removing collection-header--mobile-overlay during collapse forces fixed→in-flow mid-animation (scroll jitter).
 * Defer peeling overlay until the collapse motion finishes (~ MOBILE_CHROME_COLLAPSE_MS).
 */
function scheduleMobileOverlayRemovalAfterCollapse(s, ms) {
  if (!s || !s.header) return;
  clearMobileOverlayCollapseTimer(s);
  s.mobileOverlayCollapseTimer = setTimeout(function () {
    s.mobileOverlayCollapseTimer = null;
    if (!s.header) return;
    if (s.state !== "m-full" && s.state !== "m-nav-only") return;
    s.header.classList.remove("collection-header--mobile-overlay");
  }, ms);
}

function clearMobileChromeReveal(s) {
  if (!s) return;
  clearMobileOverlayCollapseTimer(s);
  clearRevealStaggerTimers(s);
  clearDesktopRow3Reveal(s);
  if (s.chromeRevealTimer) {
    clearTimeout(s.chromeRevealTimer);
    s.chromeRevealTimer = null;
  }
  s.header && s.header.classList.remove("collection-header--chrome-expand");
  s.header && s.header.classList.remove("collection-header--chrome-collapse");
  s.bottomNav && s.bottomNav.classList.remove("mosaic-chrome-expand");
  s.bottomNav && s.bottomNav.classList.remove("mosaic-chrome-collapse");
}

function setMobileInstantHideMode(s, on) {
  if (!s) return;
  if (s.header) s.header.classList.toggle("collection-header--mobile-hide-instant", !!on);
  if (s.bottomNav) s.bottomNav.classList.toggle("ch-bottom-nav--instant-hide", !!on);
}

function showBottomNavNow(s) {
  if (!s || !s.bottomNav) return;
  setMobileInstantHideMode(s, false);
  s.bottomNav.classList.add("ch-bottom-nav--lock-visible");
  s.bottomNav.classList.remove("ch-hidden");
  s.bottomNav.classList.remove("ch-bottom-nav--hidden");
}

function hideBottomNavNow(s) {
  if (!s || !s.bottomNav) return;
  s.bottomNav.classList.remove("ch-bottom-nav--lock-visible");
  s.bottomNav.classList.add("ch-hidden");
  s.bottomNav.classList.add("ch-bottom-nav--hidden");
}

function showMobileBottomNavOnly(section) {
  var s = sectionsState.get(section);
  if (!s || !isMosaicMobileView()) return;

  clearBttHideTimer(s);
  clearMobileOverlayCollapseTimer(s);
  clearMobileChromeReveal(s);
  setMobileInstantHideMode(s, false);

  if (s.header) s.header.classList.remove("collection-header--mobile-overlay");
  setMobileBackToTopVisible(s, false);
  s.state = "m-nav-only";
  syncMosaicMobileHeaderChrome(section);
  syncHeaderRowsCollapsedClass(section);
  showBottomNavNow(s);
  s.settleUntil = performance.now() + ROW_EASE_MS;
  syncScrollAfterLayout(section);
}

/** Mobile expand/collapse is driven by classes on .collection-header; CSS controls child rows. */
function revealMobileChromeFromParentState(section, s) {
  s.revealStaggerTimers = [];
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      setMobileBackToTopVisible(s, !atTop());
      showBottomNavNow(s);
    });
  });
}

function showAll(section) {
  var s = sectionsState.get(section);
  if (!s) return;

  clearMobileOverlayCollapseTimer(s);

  var wasHidden =
    s.state === "hidden" ||
    s.state === "m-full" ||
    s.state === "m-nav-only";

  clearBttHideTimer(s);
  clearDesktopRow3Reveal(s);
  setMobileInstantHideMode(s, false);

  if (isMosaicMobileView() && wasHidden) {
    clearMobileChromeReveal(s);

    s.state = "all-visible";
    s.settleUntil = performance.now() + MOBILE_CHROME_REVEAL_MS;
    syncScrollAfterLayout(section);

    syncMosaicMobileHeaderChrome(section);
    syncHeaderRowsCollapsedClass(section);

    s.header.classList.add("collection-header--chrome-expand");
    if (!atTop()) s.header.classList.add("collection-header--mobile-overlay");
    s.bottomNav && s.bottomNav.classList.add("mosaic-chrome-expand");

    revealMobileChromeFromParentState(section, s);

    s.chromeRevealTimer = setTimeout(function () {
      clearMobileChromeReveal(s);
    }, MOBILE_CHROME_REVEAL_MS);

    return;
  }

  if (isMosaicMobileView()) {
    setMobileBackToTopVisible(s, !atTop());
    showBottomNavNow(s);
  } else {
    var staggerDesktopRow3 =
      wasHidden &&
      !atTop() &&
      !prefersReducedMotion() &&
      DESKTOP_ROW3_STAGGER_MS > 0;

    s.row2 && s.row2.classList.remove("ch-hidden");

    if (atTop()) {
      if (s.row3) {
        s.row3.classList.add("ch-hidden");
        s.row3.classList.remove("is-visible");
      }
      scheduleBackToTopHidden(s);
    } else if (staggerDesktopRow3 && s.row3) {
      s.desktopRow3RevealTimer = setTimeout(function () {
        s.desktopRow3RevealTimer = null;
        if (s.state !== "all-visible" || !s.row3) return;
        s.row3.classList.remove("ch-hidden");
        s.row3.classList.add("is-visible");
        if (s.backToTopBtn) s.backToTopBtn.removeAttribute("hidden");
      }, DESKTOP_ROW3_STAGGER_MS);
    } else {
      if (s.row3) {
        s.row3.classList.remove("ch-hidden");
        s.row3.classList.add("is-visible");
      }
      if (s.backToTopBtn) s.backToTopBtn.removeAttribute("hidden");
    }
  }

  s.state = "all-visible";
  if (wasHidden) {
    s.settleUntil =
      performance.now() +
      (isMosaicMobileView()
        ? MOBILE_CHROME_REVEAL_MS
        : DESKTOP_LAYOUT_SETTLE_MS);
    syncScrollAfterLayout(section);
  } else {
    s.settleUntil = 0;
  }

  syncMosaicMobileHeaderChrome(section);
  syncHeaderRowsCollapsedClass(section);
}

/** Desktop (≥769px): scroll down → hide row2 + back-to-top row; pause / scroll up restores via showAll. */
function hideAllDesktop(section) {
  var s = sectionsState.get(section);
  if (!s) return;
  if (s.state === "hidden") return;

  clearBttHideTimer(s);
  clearMobileChromeReveal(s);

  s.row2 && s.row2.classList.add("ch-hidden");
  if (s.row3) {
    s.row3.classList.add("ch-hidden");
    s.row3.classList.remove("is-visible");
  }
  scheduleBackToTopHidden(s);

  s.state = "hidden";
  s.settleUntil = performance.now() + DESKTOP_ROW_TRANSITION_MS;
  syncScrollAfterLayout(section);
  syncMosaicMobileHeaderChrome(section);
  syncHeaderRowsCollapsedClass(section);
}

/** Mobile: scroll down → smoothly collapse the collection-header parent state and bottom nav. */
function hideAllMobileFull(section) {
  var s = sectionsState.get(section);
  if (!s) return;
  if (s.state === "m-full") return;

  if (s.state === "m-nav-only") {
    clearBttHideTimer(s);
    clearMobileChromeReveal(s);
    setMobileInstantHideMode(s, false);
    hideBottomNavNow(s);
    s.state = "m-full";
    s.settleUntil = performance.now() + ROW_EASE_MS;
    syncScrollAfterLayout(section);
    syncMosaicMobileHeaderChrome(section);
    return;
  }

  clearBttHideTimer(s);
  clearMobileChromeReveal(s);
  setMobileInstantHideMode(s, false);

  var hadDeferredOverlayRemoval =
    !!(s.header && s.header.classList.contains("collection-header--mobile-overlay") && !atTop());

  if (hadDeferredOverlayRemoval) {
    scheduleMobileOverlayRemovalAfterCollapse(s, MOBILE_CHROME_COLLAPSE_MS);
  } else if (s.header) {
    s.header.classList.remove("collection-header--mobile-overlay");
  }

  if (s.header) s.header.classList.add("collection-header--chrome-collapse");
  if (s.bottomNav) s.bottomNav.classList.add("mosaic-chrome-collapse");
  setMobileBackToTopVisible(s, false);
  hideBottomNavNow(s);

  s.state = "m-full";
  s.settleUntil = performance.now() + LAYOUT_SETTLE_MS;
  syncScrollAfterLayout(section);
  syncMosaicMobileHeaderChrome(section);
}

function onScroll() {
  var currentY = window.scrollY;
  var now = performance.now();

  sectionsState.forEach(function (state, section) {
    var delta = currentY - state.lastScrollY;
    var mobileView = isMosaicMobileView();
    var isSettling = !!(state.settleUntil && now < state.settleUntil);
    var recentUserInput = hasRecentUserScrollInput(now);
    var suppressMobileAutoCollapse =
      !!(mobileView && state.suppressMobileAutoCollapseUntil && now < state.suppressMobileAutoCollapseUntil);

    if (state.programmaticScrollUntil && now < state.programmaticScrollUntil) {
      if (atTop()) {
        state.programmaticScrollUntil = 0;
        hideBackToTopRow(state);
        showAll(section);
      }
      state.lastScrollY = currentY;
      return;
    }

    // 🔝 Page top: restore the full collection header and bottom nav.
    if (atTop()) {
      hideBackToTopRow(state);
      showAll(section);
      state.lastScrollY = currentY;
    } else if (
      mobileView &&
      delta > MIN_DELTA &&
      (!isSettling || recentUserInput) &&
      (!suppressMobileAutoCollapse || recentUserInput)
    ) {
      // Down-scroll must collapse chrome immediately. During reveal/settle, only trust
      // scroll deltas that follow real input; layout growth can emit synthetic deltas.
      state.lastDirection = "down";
      hideAllMobileFull(section);
      state.lastScrollY = currentY;
    } else if (mobileView && delta < -MIN_DELTA && recentUserInput) {
      state.lastDirection = "up";
      showAll(section);
      state.lastScrollY = currentY;
    } else if (isSettling) {
      // Header layout changed scrollY; do not treat it as user scroll up/down
      state.lastScrollY = currentY;
    } else if (Math.abs(delta) > MIN_DELTA) {
      if (delta > 0) {
        state.lastDirection = "down";
        if (mobileView) {
          if (!suppressMobileAutoCollapse || recentUserInput) {
            hideAllMobileFull(section);
          }
        } else {
          hideAllDesktop(section);
        }
      } else {
        state.lastDirection = "up";
        showAll(section);
      }
      state.lastScrollY = currentY;
    }

    // ⏸ Scroll idle: after down motion mobile shows only bottom nav; after up motion it keeps full chrome.
    clearTimeout(state.timer);
    var pauseMs = mobileView ? PAUSE_DELAY_MOBILE : PAUSE_DELAY;
    state.timer = setTimeout(function () {
      if (atTop()) {
        hideBackToTopRow(state);
        showAll(section);
        return;
      }
      if (mobileView && state.lastDirection === "down") {
        showMobileBottomNavOnly(section);
        return;
      }
      /* Scroll-up already called showAll; idle would run a second reveal + chrome-expand pulse. */
      if (state.state === "all-visible" && state.lastDirection === "up") return;
      showAll(section);
    }, pauseMs);
  });
}

  // ---------------------------------------------

  document.addEventListener("click", function (event) {
    if (event.target.closest("[data-collection-back-to-top]")) {
      handleBackToTop(event);
      return;
    }

    var btn = event.target.closest(".grid-selector__icon[data-mosaic-toggle]");
    if (!btn) return;
    var section = btn.closest(".shopify-section--main-collection-mosaic");
    if (!section) return;
    var list = section.querySelector("product-list.collection-mosaic__grid");
    if (!list) return;
    var mode = btn.getAttribute("data-mosaic-toggle");
    if (!mode || VALID_MODES.indexOf(mode) === -1) return;
    event.preventDefault();
    var previousMode = list.getAttribute("data-mosaic-layout") || "featured";
    if (previousMode === mode) return;
    var viewportAnchor = captureViewportAnchor(list);
    var sectionState = sectionsState.get(section);
    if (sectionState) {
      var now = performance.now();
      sectionState.settleUntil = now + 2000;
      sectionState.suppressMobileAutoCollapseUntil = now + 2000;
      sectionState.lastScrollY = window.scrollY;
    }
    list.setAttribute("data-mosaic-layout", mode);
    persistLayout(list, mode);
    syncButtons(section, mode);
    if (typeof window.syncMosaicImageSizes === "function") {
      window.syncMosaicImageSizes(list);
    }
    if (typeof window.scheduleApplyMosaicCompactSlides === "function") {
      window.scheduleApplyMosaicCompactSlides(list, { force: true });
    }
    restoreViewportAnchorAfterLayout(list, viewportAnchor);
  });

  document.addEventListener("touchend", handleBackToTop, { passive: false });

  /**
   * Facets / pagination / sort use facet:update → fetch → replaceChildren on the section node.
   * An early requestAnimationFrame runs *before* that async replace, so localStorage layout was
   * never applied to the new product-list. Observe the section’s direct children; when they swap,
   * re-run initSection so applyPersistedLayout + syncButtons run on the new DOM.
   */
  function ensureMosaicSectionChildObserver(section) {
    if (!section || section._mosaicGridSectionChildObserver) return;
    section._mosaicGridSectionChildObserver = true;
    var mo = new MutationObserver(function () {
      initSection(section);
    });
    mo.observe(section, { childList: true });
  }

  function ensureAllMosaicSectionObservers() {
    var sections = document.querySelectorAll(".shopify-section--main-collection-mosaic");
    for (var i = 0; i < sections.length; i++) {
      ensureMosaicSectionChildObserver(sections[i]);
    }
  }

  function boot() {
    document.querySelectorAll(".shopify-section--main-collection-mosaic").forEach(initSection);
    ensureAllMosaicSectionObservers();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains("shopify-section--main-collection-mosaic")) {
      initSection(t);
      ensureMosaicSectionChildObserver(t);
    }
  });

})();